"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRequest = void 0;
var BlockRequest_1 = require("./BlockRequest");
var BlocksRequest_1 = require("./BlocksRequest");
var PersonsRequest_1 = require("./PersonsRequest");
var AssetsRequest_1 = require("./AssetsRequest");
var PersonRequest_1 = require("./PersonRequest");
var BroadcastRequest_1 = require("./BroadcastRequest");
var ApiRecordsRequest_1 = require("./ApiRecordsRequest");
var ApiRecordRequest_1 = require("./ApiRecordRequest");
var AddressRequest_1 = require("./AddressRequest");
var AccountRequest_1 = require("./AccountRequest");
var TelegramRequest_1 = require("./TelegramRequest");
var ExchangeRequest_1 = require("./ExchangeRequest");
var FetchRequest = /** @class */ (function () {
    function FetchRequest(baseUrl) {
        this.block = new BlockRequest_1.BlockRequest(baseUrl);
        this.blocks = new BlocksRequest_1.BlocksRequest(baseUrl);
        this.persons = new PersonsRequest_1.PersonsRequest(baseUrl);
        this.assets = new AssetsRequest_1.AssetsRequest(baseUrl);
        this.person = new PersonRequest_1.PersonRequest(baseUrl);
        this.broadcast = new BroadcastRequest_1.BroadcastRequest(baseUrl);
        this.records = new ApiRecordsRequest_1.ApiRecordsRequest(baseUrl + 'records');
        this.record = new ApiRecordRequest_1.ApiRecordRequest(baseUrl);
        this.address = new AddressRequest_1.AddressRequest(baseUrl);
        this.account = new AccountRequest_1.AccountRequest(baseUrl);
        this.telegram = new TelegramRequest_1.TelegramRequest(baseUrl + 'telegrams');
        this.exchange = new ExchangeRequest_1.ExchangeRequest(baseUrl + 'exchange');
    }
    return FetchRequest;
}());
exports.FetchRequest = FetchRequest;
